import React from 'react'
import { Widget } from 'features/types'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { DisplayOption } from 'enums'

import PreSearchDataGuards from '../share/guards/PreSearchDataGuards'
import PostSearchDataGuards from '../share/guards/PostSearchDataGuards'
import RunSearchEffect from '../share/RunSearchEffect'
import DemographicTable from '../share/Table'
import DemographicIndexBubble from '../share/IndexBubble'
import { DemographicWidgetsType } from '../types'

const SocialWebDemographicWidget: Widget = ({ widgetId }) => {
  const { displayOption } = useDashboardWidgetSetting<DemographicWidgetsType>(widgetId)

  return (
    <UnexpectedErrorBoundary>
      <PreSearchDataGuards widgetId={widgetId}>
        <RunSearchEffect widgetId={widgetId}>
          <PostSearchDataGuards widgetId={widgetId}>
            <>
              {displayOption === DisplayOption.TABLE && <DemographicTable widgetId={widgetId} />}
              {displayOption === DisplayOption.BUBBLE && (
                <DemographicIndexBubble widgetId={widgetId} />
              )}
            </>
          </PostSearchDataGuards>
        </RunSearchEffect>
      </PreSearchDataGuards>
    </UnexpectedErrorBoundary>
  )
}

export default SocialWebDemographicWidget
